import { create } from 'zustand';

const initialState = {
  // Helpers for rep modals to answer and see results of a module assessment
  moduleIdToViewResults: '',
  moduleIdToAnswer: '',
  moduleName: '',
  moduleToReviewUserUuid: '',
  // Helpers to refresh rep training view after success submission
  // Functions are saved from UserTrainingContainer
  fetchRecentlyAccessedModules: () => null,
  fetchTrainingModulesList: () => null,
};

export const useModuleAssessmentStore = create((set, get) => {
  return {
    ...initialState,
    setModuleIdToViewResults: (id) => set(() => ({ moduleIdToViewResults: id })),
    setModuleIdToAnswer: (id) => set(() => ({ moduleIdToAnswer: id })),
    setModuleName: (moduleName) => set(() => ({ moduleName })),
    setModuleToReviewUserUuid: (moduleToReviewUserUuid) => set(() => ({ moduleToReviewUserUuid })),
    setFetchFunctions: ({ fetchRecentlyAccessedModules, fetchTrainingModulesList }) =>
      set(() => ({ fetchRecentlyAccessedModules, fetchTrainingModulesList })),
  };
});
